/* David Gatter — kleines, abhängigkeitsfreies Theme-Script */
(function () {
  'use strict';

  /* Mobile-Navigation */
  var burger = document.querySelector('.dg-burger');
  var nav = document.querySelector('.dg-nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('is-open'); });
    });
  }

  /* Scroll-Reveal */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Leseprobe: Blättern */
  document.querySelectorAll('[data-reader]').forEach(function (reader) {
    var track = reader.querySelector('.dg-pages');
    var pages = Array.prototype.slice.call(track.children);
    var prev = reader.querySelector('[data-prev]');
    var next = reader.querySelector('[data-next]');
    var dots = reader.querySelector('.dg-dots');
    var current = 0;

    pages.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Doppelseite ' + (i + 1));
      b.addEventListener('click', function () { go(i); });
      dots.appendChild(b);
    });

    function go(i) {
      current = (i + pages.length) % pages.length;
      track.scrollTo({ left: pages[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      paint();
    }
    function paint() {
      Array.prototype.forEach.call(dots.children, function (d, i) {
        if (i === current) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    prev && prev.addEventListener('click', function () { go(current - 1); });
    next && next.addEventListener('click', function () { go(current + 1); });

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = track.clientWidth;
        current = Math.round(track.scrollLeft / (w + 12));
        paint();
      }, 80);
    });
    paint();

    /* Lightbox */
    var lb = document.querySelector('.dg-lightbox');
    if (lb) {
      var lbImg = lb.querySelector('img');
      pages.forEach(function (p) {
        var img = p.querySelector('img');
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function () {
          lbImg.src = img.dataset.full || img.currentSrc || img.src;
          lb.classList.add('is-open');
        });
      });
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.closest('button')) lb.classList.remove('is-open');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') lb.classList.remove('is-open');
        if (!lb.classList.contains('is-open')) {
          if (e.key === 'ArrowRight' && reader.matches(':hover')) go(current + 1);
          if (e.key === 'ArrowLeft' && reader.matches(':hover')) go(current - 1);
        }
      });
    }
  });

  /* Sticky-Kaufleiste: erscheint, sobald der Hero aus dem Bild ist */
  var sticky = document.querySelector('[data-sticky-buy]');
  var hero = document.querySelector('.dg-hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky');
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0.05 }).observe(hero);
  }

  /* Mengenwähler */
  document.querySelectorAll('.dg-qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelector('[data-minus]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || 1, 10) - 1);
    });
    q.querySelector('[data-plus]').addEventListener('click', function () {
      input.value = parseInt(input.value || 1, 10) + 1;
    });
  });

  /* In den Warenkorb per AJAX (fällt auf normales Formular zurück) */
  var toast = document.querySelector('.dg-toast');
  var countEl = document.querySelector('.dg-cart-count');
  function showToast(html) {
    if (!toast) return;
    toast.innerHTML = html;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 4500);
  }
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Wird eingepackt …';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data.status) { throw new Error(data.description || 'Fehler'); }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        if (countEl) { countEl.textContent = cart.item_count; countEl.dataset.count = cart.item_count; }
        showToast('David ist im Warenkorb. <a href="/cart">Zum Warenkorb →</a>');
      }).catch(function (err) {
        showToast('Das hat leider nicht geklappt: ' + err.message);
      }).finally(function () {
        btn.disabled = false; btn.textContent = label;
      });
    });
  });
})();
